(function () {
    "use strict";

    // @ngInject
    function ContactFormOnMobileControllerCtor($scope, $injector, $modalInstance, AnalyticsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ContactFormOnMobileController';
        AnalyticsService.trackPageView(this, 'ContactFormOnMobileView');

        this.$modalInstance = $modalInstance;
    }

    Controllers.ContactFormOnMobileController = Class(Controllers.BaseController, {
        constructor: ContactFormOnMobileControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },
    });
}());